// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3HrwI","paramInput":"JobSimulator_paramInput__3c3SG","input":"JobSimulator_input__3eABk"};